import { AxiosError } from 'axios';
import { axiosInstance } from '../api/axios.instance';
import { API_CONFIG } from '../api/config';
import { 
  ScraperInfoResponseSchema,
  transformScraperInfoApiToUi,
  ScraperInfoUi 
} from '../schemas/scraper/scraper-info';

const extractErrorMessage = (error: any): string => {
  if (!error) return 'Error desconocido';
  
  if (typeof error === 'string') return error;
  
  if (error instanceof Error) return error.message;
  
  if (error.message) return String(error.message);
  
  if (error.detail) return String(error.detail);
  
  try {
    return JSON.stringify(error);
  } catch {
    return String(error);
  }
};

export class ScraperService {
  static async obtenerInfoScraper(): Promise<ScraperInfoUi> {
    try {
      const response = await axiosInstance.get(API_CONFIG.ENDPOINTS.SCRAPER.INFO);
      const validatedResponse = ScraperInfoResponseSchema.parse(response.data);
      
      if (validatedResponse.status_code >= 400) {
        return {
          id: null,
          fechaInicio: null,
          fechaFin: null,
          totalTimeSeg: null,
          fechaInicioFormatted: null,
          fechaFinFormatted: null,
          totalTimeFormatted: null,
          hasError: true,
          error: validatedResponse.data.error 
            ? extractErrorMessage(validatedResponse.data.error)
            : 'Error al obtener información del scraper'
        };
      }
      
      return transformScraperInfoApiToUi(validatedResponse.data);
    } catch (error) {
      console.error('Error al obtener información del scraper:', error);
      
      let errorMessage = 'Error desconocido al obtener información del scraper';
      
      if (error instanceof AxiosError) {
        if (error.response?.data?.detail) {
          errorMessage = String(error.response.data.detail);
        } else if (error.response?.data?.data?.error) {
          errorMessage = extractErrorMessage(error.response.data.data.error);
        } else if (error.message) {
          errorMessage = error.message;
        }
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }
      
      return {
        id: null,
        fechaInicio: null,
        fechaFin: null,
        totalTimeSeg: null,
        fechaInicioFormatted: null,
        fechaFinFormatted: null,
        totalTimeFormatted: null,
        hasError: true,
        error: errorMessage
      };
    }
  }
}
